module.exports = __webpack_public_path__ + "img/boy panique.105b5a87.png";